const routes = {
    home: '/',
    login: '/login',
    signup: '/signup',
    sso: '/login/sso',
    qsciSignup: '/quickstart-ci-cd',
    buildDistroSignup: '/build-distribution',
    twoFactorAuth: '/login/verifyCode',
    verifyEmail: '/login/verifyEmail',
    mobile: '/mobile',
    dashboard: '/dashboard',
    user: '/dashboard/user/settings',
    org: '/dashboard/org/:orgIdParam',
    orgSettings: '/dashboard/org/:orgIdParam/settings/:orgSettingsTabType',
    app: '/dashboard/org/:orgIdParam/app/:appIdParam',
    setup: '/dashboard/org/:orgIdParam/app/:appIdParam/setup',
    setupSteps: '/dashboard/org/:orgIdParam/app/:appIdParam/setup/:setupTypeParam',
    newAppQuickStartCI: '/dashboard/org/:orgIdParam/quick-start-ci',
    newAppQuickStartCISteps: '/dashboard/org/:orgIdParam/quick-start-ci/:setupTypeParam',
    mobileAddTestDevice: '/dashboard/org/:orgIdParam/app/:appIdParam/add-test-device',
    quickStartCI: '/dashboard/org/:orgIdParam/app/:appIdParam/quick-start-ci',
    quickStartCISteps: '/dashboard/org/:orgIdParam/app/:appIdParam/quick-start-ci/:setupTypeParam',
    releases: '/dashboard/org/:orgIdParam/app/:appIdParam/releases',
    appOverview: '/dashboard/org/:orgIdParam/app/:appIdParam/overview',
    appBuilds: '/dashboard/org/:orgIdParam/app/:appIdParam/builds',
    appBucket: '/dashboard/org/:orgIdParam/app/:appIdParam/bucket/:bucketIdParam',
    sharedWithMeBucket: '/dashboard/org/:orgIdParam/app/:appIdParam/shared-with-me',
    appFeatureFlags: '/dashboard/org/:orgIdParam/app/:appIdParam/feature-flags',
    appRollouts: '/dashboard/org/:orgIdParam/app/:appIdParam/rollouts',
    appSettings: '/dashboard/org/:orgIdParam/app/:appIdParam/appSettings',
    appSettingsType: '/dashboard/org/:orgIdParam/app/:appIdParam/appSettings/:settingType',
    integrations: '/dashboard/org/:orgIdParam/app/:appIdParam/appSettings/integrations',
    integrationRedirect: '/dashboard/org/:orgIdParam/app/:appIdParam/appSettings/integrations/:integrationTypeParam',
    release: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam',
    releaseStep: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/step/:releaseStepTypeParam',
    releaseStepTab:
        '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/step/:releaseStepTypeParam/:releaseStepTabType',
    stepRunsSummary:
        '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/stepRunsSummary/:groupIndexParam/:archetypeGroupIndexParam',
    stepRun: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/step/:stepRunIdParam',
    stepRunTab:
        '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/step/:stepRunIdParam/:releaseStepTabType',
    releaseOverview: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/overview',
    monitoring: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/rollout/:tabTypeParam',
    featureFlags: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/featureFlags',
    appAutomations: '/dashboard/org/:orgIdParam/app/:appIdParam/appSettings/automations',
    buildDetails: '/dashboard/org/:orgIdParam/app/:appIdParam/release/:releaseIdParam/buildDetails',
    publicBucket: '/bucket/:bucketHashParam',
    publicBuild: '/bucket/:bucketHashParam/build/:buildHashParam',
    appHomeGetStarted: '/dashboard/org/:orgIdParam/app/:appIdParam/get-started',
    automationsToolbox: '/dashboard/org/:orgIdParam/app/:appIdParam/automationsToolbox',
    automationsToolboxIntegrations:
        '/dashboard/org/:orgIdParam/app/:appIdParam/automationsToolbox/integrations/:integrationCapability',
    releaseCalendar: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/schedule',
    appReleaseCalendar: '/dashboard/org/:orgIdParam/app/:appIdParam/schedule',
    releaseTimeline: '/dashboard/org/:orgIdParam/app/:appIdParam/releases/:releaseIdParam/timeline',
    appTimeline: '/dashboard/org/:orgIdParam/app/:appIdParam/timeline',
};

export default routes;
